import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ConsultationForm from './ConsultationForm';
import { motion } from 'framer-motion';


const Hero = () => {
  const [showConsultation, setShowConsultation] = useState(false);
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Transform Your Space with<br />Astro Interiors</h1>
        <p className="hero-subtitle">
          Creating harmonious living spaces with Vastu principles. Your journey to a balanced home starts here.
        </p>
        <div className="hero-buttons">
          <Link to="/services" className="btn btn-primary">
            Explore Our Services
          </Link>
          <button
            className="btn btn-outline"
            onClick={() => setShowConsultation(true)}
            style={{ cursor: 'pointer' }}
          >
            Free Consultation
          </button>
          {showConsultation && (
            <ConsultationForm
              isOpen={showConsultation}
              onClose={() => setShowConsultation(false)}
              type="consultation"
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
